"use client";

import React from "react";
import { ConvexClientProvider } from "@/components/ConvexClientProvider";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/lib/auth-context";
import { DynamicCookieConsent, DynamicFloatingWidget } from "@/components/DynamicClients";
import { SiteThemeBridge } from "@/components/SiteThemeBridge";

const convexConfigured = Boolean(process.env.NEXT_PUBLIC_CONVEX_URL);
export function Providers({ children, modal }: { children: React.ReactNode; modal: React.ReactNode }) {
  return (
    <ConvexClientProvider>
      <AuthProvider>
        <ThemeProvider>
          {convexConfigured && <SiteThemeBridge />}
          {children}
          {modal}
          <DynamicCookieConsent />
          <DynamicFloatingWidget />
        </ThemeProvider>
      </AuthProvider>
    </ConvexClientProvider>
  );
}
